import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './fil-button-group.styles.js';

/**
 * @tag fil-button-group
 * @property {boolean} [stacked=false] Whether if the buttons should stack on each other or not
 * @property {string} [position=left] Position of the button
 * @property {boolean} [autoSize=false] Determines if inner buttons size depend on their content
 */
export class FilButtonGroup extends LitElement {
  static properties = {
    stacked: { type: Boolean },
    position: { type: String }, // 'center' | 'left'
    autoSize: { type: Boolean }, // If true, inner buttons size will depend on their content
  };

  static styles = [
    componentStyles,
    css`
      ::slotted(fil-button) {
        width: var(--fil-button-width);
      }
    `,
  ];

  constructor() {
    super();
    this.position = 'left';
    this.stacked = false;
  }

  wrapperTemplate() {
    return html`<div class="fil-button-group-wrapper fil-button-group-wrapper--${this.position}">
      ${this.buttonGroupTemplate()}
    </div>`;
  }

  buttonGroupTemplate() {
    const classes = {
      'fil-button-group--stacked': this.stacked,
      'fil-button-group--auto': this.autoSize,
    };

    return html`<div
      class="fil-button-group${classMap(classes)}"
      role="group"
      aria-label="Button Group"
    >
      <slot></slot>
    </div>`;
  }

  render() {
    if (this.position === 'center' || this.position === 'right') {
      return this.wrapperTemplate();
    }
    return this.buttonGroupTemplate();
  }
}

export default FilButtonGroup;
